import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// Check auth at render time so updates to localStorage take effect immediately
export const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                const token = localStorage.getItem('token');
                const expirationToken = localStorage.getItem('expiration-token');
                const expirationTime = expirationToken
                    ? (parseInt(expirationToken, 10) * 1000) - 60000
                    : null;

                if (expirationTime && Date.now() >= expirationTime) {
                    localStorage.clear();
                }

                return token ? <Component {...props} /> : <Redirect to="/" />;
            }}
        />
    );
};

export default PrivateRoute;